import { render, staticRenderFns } from "./TrainingHomeComponent.vue?vue&type=template&id=002988ac"
import script from "./TrainingHomeComponent.vue?vue&type=script&lang=js"
export * from "./TrainingHomeComponent.vue?vue&type=script&lang=js"
import style0 from "./TrainingHomeComponent.vue?vue&type=style&index=0&id=002988ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports